export default __webpack_public_path__ + "static/media/1537.cb82125c.png";